export default function ShortcutCard({ icon, title, description, onClick, className, style }: {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <button
      onClick={onClick}
      className={`puzzle-card card${className ? ` ${className}` : ''}`}
      style={{
        borderRadius: 'var(--radius-card)', padding: '20px 22px',
        textAlign: 'left', cursor: 'pointer',
        display: 'flex', flexDirection: 'column', gap: 6,
        transition: 'transform .15s, border-color .15s, box-shadow .15s',
        fontFamily: 'var(--font-ui)', color: 'var(--ink)',
        ...style,
      }}
    >
      <div style={{ fontSize: 24, color: 'var(--accent)' }}>{icon}</div>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 500 }}>{title}</div>
      <div style={{ fontSize: 13, color: 'var(--muted)' }}>{description}</div>
    </button>
  );
}
